import { render, staticRenderFns } from "./PurchaseRequisitionMGT.vue?vue&type=template&id=24411c3a&scoped=true&"
import script from "./PurchaseRequisitionMGT.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitionMGT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24411c3a",
  null
  
)

export default component.exports